import { createFileRoute } from '@tanstack/react-router'
import AdminHomePage from '@/spa/pages/admin/AdminHomePage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/admin/')({
  component: AdminHomePage,
  errorComponent: routeErrorComponent,
})
